/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ex_TitleInputs */

const en_diff_ex_title = /** @type {(inputs: Diff_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparing two versions of a record`)
};

const ko_diff_ex_title = /** @type {(inputs: Diff_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레코드의 두 버전 비교하기`)
};

const ja_diff_ex_title = /** @type {(inputs: Diff_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードの 2 つのバージョンを比べる`)
};

/**
* | output |
* | --- |
* | "Comparing two versions of a record" |
*
* @param {Diff_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ex_title = /** @type {((inputs?: Diff_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ex_title(inputs)
	if (locale === "ko") return ko_diff_ex_title(inputs)
	return ja_diff_ex_title(inputs)
});